export const TIME_WANTED_MODES = Object.freeze({
  ASAP: 'ASAP',
  ADVANCE: 'ADVANCE',
})

export const ALLOWED_TIME_WANTED_MODES = [TIME_WANTED_MODES.ASAP, TIME_WANTED_MODES.ADVANCE]
